import { EventDashboard } from "./EventDashboard";

export default EventDashboard;
